import type { LucideIcon } from "lucide-react";
import GradientBorderCard from "@/components/GradientBorderCard";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  desc: string;
  index: number;
}

const ServiceCard = ({ icon: Icon, title, desc, index }: ServiceCardProps) => {
  return (
    <GradientBorderCard index={index} className="p-8 text-center">
      <Icon className="w-10 h-10 text-primary mx-auto mb-4 group-hover:scale-110 transition-transform" />
      <h3 className="text-lg font-bold text-foreground mb-3">{title}</h3>
      <p className="text-muted-foreground text-sm leading-relaxed">{desc}</p>
    </GradientBorderCard>
  );
};

export default ServiceCard;
